import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const CloseIcon = ({
  width = "24",
  height = "24",
  color = "#D32F2F",
  style,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 10.587L16.95 5.63699L18.364 7.05099L13.414 12.001L18.364 16.951L16.949 18.365L11.999 13.415L7.04999 18.365L5.63599 16.95L10.586 12L5.63599 7.04999L7.04999 5.63799L12 10.587Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
